<script>
  import { LayerCake, Svg, Html } from "layercake";
  import { scaleOrdinal } from "d3-scale";
  import {
    timeParse,
    timeFormat,
    timeFormatDefaultLocale,
  } from "d3-time-format";
  import { format, precisionFixed } from "d3-format";

  import AxisX from "./layercake/AxisX.svelte";
  import AxisY from "./layercake/AxisY.svelte";
  import Column from "./layercake/Column.svelte";
  import Line from "./layercake/Line.svelte";
  import Area from "./layercake/Area.svelte";
  import SharedTooltip from "./layercake/SharedTooltip.svelte";
  import { beforeUpdate } from "svelte";

  const xKey = "0";
  const yKey = "1";
  const zKey = "key";

  export let data;
  export let viewGridLines = true;
  export let strokeWidth = 3;
  let seriesNames;
  let dataLong;
  let parseDate;
  let getYTicks;
  let flatten;
  let formatTickX;
  let formatTickY;
  let yDomainValue = 1;
  $: antTicks = 1;

  beforeUpdate(() => {
    seriesNames = Object.keys(data[0]).filter((d) => d !== xKey);
    yDomainValue = 1;
    data.map((d) => {
      if (d[2] != 0) {
        yDomainValue = null;
      }
      if (d[1] > 1) {
        antTicks = 2;
      }
    });
    timeFormatDefaultLocale({
      decimal: ".",
      thousands: ",",
      grouping: [3],
      currency: ["$", ""],
      dateTime: "%a %b %e %X %Y",
      date: "%m/%d/%Y",
      time: "%H:%M:%S",
      periods: ["AM", "PM"],
      days: [
        "Søndag",
        "Mandag",
        "Tirsdag",
        "Onsdag",
        "Torsdag",
        "Fredag",
        "Lørdag",
      ],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: [
        "Januar",
        "Februar",
        "Mars",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
      shortMonths: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "mai.",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des.",
      ],
    });
    parseDate = timeParse("%Y-%m-%d");
    dataLong = seriesNames.map((key) => {
      return {
        key,
        values: data.map((d) => {
          d[xKey] = typeof d[xKey] === "string" ? parseDate(d[xKey]) : d[xKey]; 
          return {
            key,
            [yKey]: +d[key],
            [xKey]: d[xKey],
          };
        }),
      };
    });
    getYTicks = (list) => {
      return [list[0], list[list.length - 1]];
    };
    // Make a flat array of the `values` of our nested series
    // we can pluck the `value` field from each item in the array to measure extents
    flatten = (data) =>
      data.reduce((memo, group) => {
        return memo.concat(group.values);
      }, []);
    formatTickX = timeFormat("%e. %b");
    formatTickY = (d) => format(`.${precisionFixed(d)}s`)(d);
  });


</script>

<style>
  .chart-container {
    width: 100%;
    height: 100%;
  }
</style>

{#await data then data}
  <div class="chart-container">
    <LayerCake
      padding={{ bottom: 10, left: viewGridLines ? 14 : 0 }}
      x={xKey}
      y={yKey}
      z={zKey}
      yDomain={[0, yDomainValue]}
      zScale={scaleOrdinal()}
      zDomain={seriesNames}
      flatData={flatten(dataLong)}
      data={dataLong}>
      <Svg>
        <AxisX
          gridlines={false}
          ticks={getYTicks(data.map((d) => d[xKey]).sort((a, b) => a - b))}
          formatTick={formatTickX}
          snapTicks={true} />
        <AxisY
          ticks={viewGridLines ? antTicks : 0}
          formatTick={formatTickY}
          gridlines={viewGridLines} />
        <Column />
        <Area />
        <Line {strokeWidth} />
      </Svg>

      <Html>
        <SharedTooltip formatTitle={formatTickX} dataset={data} />
      </Html>
    </LayerCake>
  </div>
{/await}
